export default "__VITE_ASSET__CsPsM2rv__"